var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collapsible",
      class: {
        "collapsible--collapsed": !_vm.opened,
      },
    },
    [
      _c(
        "div",
        {
          ref: "trigger",
          staticClass: "collapsible__trigger",
          on: { click: _vm.toggle },
        },
        [_vm._t("trigger")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "content", staticClass: "collapsible__content" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }